import { generateHeaderHTML } from './components/header';
import { generateHeroHTML } from './components/hero';
import { generateTrustHTML } from './components/trust';
import { generateAuthorityHTML } from './components/authority';
import { generateServicesHTML } from './components/services';
import { generateProofTableHTML } from './components/proof-table';
import { generateProcessHTML } from './components/process';
import { generateBenefitsHTML } from './components/benefits';
import { generateTeamHTML } from './components/team';
import { generateGalleryHTML } from './components/gallery';
import { generateTestimonialsHTML } from './components/testimonials';
import { generateFaqHTML } from './components/faq';
import { generateCtaHTML } from './components/cta';
import { generateStickyCtaHTML } from './components/sticky-cta';
import { generateFooterHTML } from './components/footer';
import { generateCookieHTML } from './components/cookie';

export function generateComponentHTML(component: any, settings: any): string {
  const { type, data } = component;
  switch (type) {
    case 'header': return generateHeaderHTML(data, settings);
    case 'hero': return generateHeroHTML(data, settings);
    case 'trust': return generateTrustHTML(data, settings);
    case 'authority': return generateAuthorityHTML(data, settings);
    case 'services': return generateServicesHTML(data, settings);
    case 'proofTable': return generateProofTableHTML(data, settings);
    case 'process': return generateProcessHTML(data, settings);
    case 'benefits': return generateBenefitsHTML(data, settings);
    case 'team': return generateTeamHTML(data, settings);
    case 'gallery': return generateGalleryHTML(data, settings);
    case 'testimonials': return generateTestimonialsHTML(data, settings);
    case 'faq': return generateFaqHTML(data, settings);
    case 'cta': return generateCtaHTML(data, settings);
    case 'stickyCta': return generateStickyCtaHTML(data, settings);
    case 'footer': return generateFooterHTML(data, settings);
    case 'cookie': return generateCookieHTML(data, settings);
    default: return `<!-- Unknown component: ${type} -->`;
  }
}
